export default __webpack_public_path__ + "static/media/home-mobile-banner-cn.fd888cd4.webp";